"use client";
import Link from "next/link";
import { useEffect, useState } from "react";
import { FiCheckCircle, FiLayers, FiTool, FiZap, FiDollarSign, FiHelpCircle, FiPhone } from "react-icons/fi";

const sections = [
  { id: "deskripsi", label: "Deskripsi", icon: <FiCheckCircle /> },
  { id: "keunggulan", label: "Kenapa Kami", icon: <FiLayers /> },
  { id: "layanan", label: "Layanan", icon: <FiTool /> },
  { id: "studi-kasus", label: "Studi Kasus", icon: <FiZap /> },
  { id: "harga", label: "Harga", icon: <FiDollarSign /> },
  { id: "faq", label: "FAQ", icon: <FiHelpCircle /> },
  { id: "kontak", label: "Kontak", icon: <FiPhone /> },
];

export default function FloatingNav() {
  const [activeSection, setActiveSection] = useState("");

  useEffect(() => {
    const handleScroll = () => {
      let currentSection = "";
      for (const section of sections) {
        const el = document.getElementById(section.id);
        if (el) {
          const rect = el.getBoundingClientRect();
          if (rect.top <= 120 && rect.bottom >= 120) {
            currentSection = section.id;
            break;
          }
        }
      }
      setActiveSection(currentSection);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const linkClass = (id: string) =>
    `group flex items-center gap-2 px-4 py-2 rounded-xl transition-all duration-300
     ${
       activeSection === id
         ? "bg-gradient-to-r from-purple-600 to-orange-600 text-white shadow-lg scale-[1.03]"
         : "text-gray-700 hover:bg-gray-100 hover:shadow-sm"
     }`;

  return (
    <>
      {/* Desktop Floating Nav */}
      <nav className="sticky top-6 z-50 hidden md:block bg-white border shadow-xl p-6 rounded-2xl max-w-xs mt-8">
        <h3 className="text-sm font-semibold mb-4 text-gray-500 uppercase tracking-wider">
          Navigasi Cepat
        </h3>
        <ul className="space-y-2">
          {sections.map((s) => (
            <li key={s.id}>
              <Link href={`#${s.id}`} className={linkClass(s.id)} title={s.label}>
                <span className="text-lg">{s.icon}</span>
                <span className="text-sm font-medium">{s.label}</span>
              </Link>
            </li>
          ))}
        </ul>
      </nav>

      {/* Mobile Sticky Bottom Nav */}
      <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t p-2 flex justify-around items-center text-xs lg:hidden shadow-xl">
        {sections.map((s) => (
          <Link
            key={s.id}
            href={`#${s.id}`}
            title={s.label}
            className={`flex flex-col items-center gap-0.5 px-2 py-1 transition-all duration-300 ${
              activeSection === s.id
                ? "text-purple-600 font-semibold"
                : "text-gray-500 hover:text-purple-600"
            }`}
          >
            <span className="text-lg">{s.icon}</span>
            <span className="text-[10px]">{s.label}</span>
          </Link>
        ))}
      </nav>
    </>
  );
}
